/*
  Module configuration file
 */
import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {ModuleConfiguration} from "../core/config/module-configuration";
import {KiwisConfiguration} from "./kiwis-configuration";
import {ChartConfiguration} from "./chart-configuration";
import {StationPopupConfiguration} from "./station-popup-configuration";
import {MessageConfiguration} from "../core/config/message-configuration";
import {MapViewerConfiguration} from "./map-viewer-configuration";

@JsonObject()
export class TrackerConfiguration {
    @JsonProperty()
    declare urlBase: string;
    @JsonProperty()
    declare siteId: number;
    constructor() {
    }
}

@JsonObject()
export class MapFinderMapConfiguration extends ModuleConfiguration {
    @JsonProperty()
    declare id: string;
    @JsonProperty()
    declare title: string;
    @JsonProperty()
    declare titleFull: string;
    @JsonProperty()
    declare url: string;
    @JsonProperty()
    declare login?: boolean;
    constructor() {
        super();
    }
}

@JsonObject()
export class MapFinderConfiguration extends ModuleConfiguration {
    @JsonProperty()
    declare id: string;
    @JsonProperty()
    declare maps: MapFinderMapConfiguration[];
    @JsonProperty()
    declare apps?: MapFinderMapConfiguration[];
    constructor() {
        super();
    }
}

@JsonObject()
export class WebMapMetaConfiguration extends ModuleConfiguration {
    @JsonProperty()
    declare alerts: MessageConfiguration[];
    @JsonProperty()
    declare mapFinder?: MapFinderConfiguration[];
    constructor() {
        super();
    }
}

@JsonObject()
export class MessdatenConfiguration extends MapViewerConfiguration {
    /**
     * KIWIS configuration
     */
    @JsonProperty({type: KiwisConfiguration})
    declare kiwis: KiwisConfiguration;

    /**
     * Popup for measurement stations
     */
    @JsonProperty()
    declare stationPopup: StationPopupConfiguration;

    /**
     * Chart configuration
     */
    @JsonProperty()
    declare chart: ChartConfiguration;

    constructor() {
        super();
    }
}
